@import (reference) '../../../../../constants/spacing.module.less';

.storeList {
  margin-bottom: @space-24;
  padding: 0;
}

.store-row {
  display: flex;
  border-bottom: 1px solid var(--grey-200);
  justify-content: space-between;
  padding: 0 @space-16 @space-8;
  &:last-child {
    border-bottom: none;
  }
  &:first-child {
    padding-top: 8px;
  }
}

.store-row__logo {
  height: 32px;
  width: 32px;
}

.store-row__info {
  align-items: center;
  display: flex;
}

.store-row__label {
  margin-left: 8px;
}

.store-row__details {
  align-items: center;
  display: flex;
  color: var(--grey-700);
}

.store-row__circle {
  color: #d9d9d9;
  margin: 0 4px;
  height: 4px;
  width: 4px;
}

.storeIcons {
  img {
    margin-right: @space-8;
  }
}

.noProvidersBanner {
  margin-bottom: @space-24;
}

.noStores {
  align-items: center;
  flex-grow: 1;
  justify-content: center;
}

.noStoresText {
  max-width: 448px;
  text-align: center;
}

.activationDescription {
  margin-bottom: @space-24;
}

.storeListContent {
  display: flex;
  flex-direction: column;
}
